import { Injectable, inject, Type } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DialogService } from 'nebula-ui-kit';
import { PerfilData } from './perfil.service';

/**
 * Lanzador del modal de perfil. El componente concreto del modal vive en `@nebula-shared/ui`; como
 * `layout` es una lib *buildable* (ng-packagr) NO puede depender de `@nebula-shared/ui` (ni estática
 * ni dinámicamente: rompe el build). Por eso el app-shell (que no es buildable) REGISTRA aquí el
 * componente, y el topbar (en layout) solo llama a {@link open} a través de data-access, de la que
 * ya depende.
 */
@Injectable({ providedIn: 'root' })
export class PerfilModalLauncher {
  private readonly dialogService = inject(DialogService);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private componentType: Type<any> | null = null;

  /** El app-shell registra el componente concreto del modal de perfil. */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register(component: Type<any>): void {
    this.componentType = component;
  }

  /** Abre el modal de perfil; emite el perfil actualizado (o `null` si se canceló o no hay componente). */
  open(): Observable<PerfilData | null | undefined> {
    if (!this.componentType) {
      return of(null);
    }
    return this.dialogService
      .open<unknown, unknown, PerfilData | null>(this.componentType, { width: '640px' })
      .afterClosed();
  }
}
